import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=bf9a8dc8&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=ts"
export * from "./CampaignList.vue?vue&type=script&lang=ts"
import style0 from "./CampaignList.vue?vue&type=style&index=0&id=bf9a8dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9a8dc8",
  null
  
)

export default component.exports